import type {TypedSchemaModifier} from 'schemaDefinition/types';
import type {
  GetDataBasedModifier,
  ManifestationV4,
} from 'services/metadata/types';
import {isNullish} from 'schemaDefinition/functions';
import {EditableBookGroupModifier} from '../manifestationSchema';

export const getManifestationBasedModifier: GetDataBasedModifier = data => {
  const savedManifestation = data as ManifestationV4;
  const modifiers: TypedSchemaModifier<ManifestationV4> = [];

  /**
   * If a saved manifestation already has bookgroup, it should not be editable
   */
  if (isNullish(savedManifestation.bookGroup)) {
    modifiers.push(EditableBookGroupModifier);
  }

  return modifiers.length > 0 ? modifiers : undefined;
};
